"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcPlannerBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_modal_behavior_1 = require("../../molecules/bc-modal/bc-modal-behavior");
var bc_planner_constants_1 = require("./bc-planner-constants");
var bc_planner_constants_2 = require("./bc-planner-constants");
var bc_planner_constants_3 = require("./bc-planner-constants");
var bc_planner_constants_4 = require("./bc-planner-constants");
var bc_planner_constants_5 = require("./bc-planner-constants");
var bc_planner_constants_6 = require("./bc-planner-constants");
var bc_planner_constants_7 = require("./bc-planner-constants");
var bc_planner_constants_8 = require("./bc-planner-constants");
var bc_planner_constants_9 = require("./bc-planner-constants");
var BcPlannerBehavior = (function (_super) {
    __extends(BcPlannerBehavior, _super);
    function BcPlannerBehavior() {
        var _this = _super.call(this) || this;
        _this.items = [];
        _this.bcPlannerNextMonthButton = "".concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-btn-next-month");
        _this.bcPlannerPreviousMonthButton = "".concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-btn-previous-month");
        _this.bcPlannerNextYearButton = "".concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-btn-next-year");
        _this.bcPlannerPreviousYearButton = "".concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-btn-previous-year");
        _this.bcPlannerDate = new Date();
        _this.bcPlannerToday = _this.bcPlannerDate.getDate();
        _this.bcPlannerYear = _this.bcPlannerDate.getFullYear();
        _this.bcPlannerMonth = _this.bcPlannerDate.getMonth();
        _this.timeOut = 0;
        return _this;
    }
    BcPlannerBehavior.setUpAll = function () {
        var plannerElements = Array.from(document.querySelectorAll(".".concat(bc_planner_constants_4.PLANNER_NAMESPACE)));
        var elements = [];
        for (var i = 0; i < plannerElements.length; i++) {
            var element = plannerElements[i];
            var bcPlannerBehavior = new BcPlannerBehavior();
            bcPlannerBehavior.setElement(element);
            bcPlannerBehavior.setUp();
            elements.push(bcPlannerBehavior);
        }
        return elements;
    };
    BcPlannerBehavior.prototype._setUp = function () {
        try {
            this.createHeadersAndPaginator();
            this.setUpDateVariables(new Date());
        }
        catch (error) {
            this.isReady = false;
        }
    };
    BcPlannerBehavior.prototype.initModal = function () {
        this.modalListPlus = new bc_modal_behavior_1.BcModalBehavior();
        this.modalListPlus.setId('modalPlanner1');
        this.modalListPlus.setUp();
    };
    BcPlannerBehavior.prototype.setUpDateVariables = function (date) {
        this.bcPlannerDate = new Date(date);
        this.bcPlannerToday = date.getDate();
        this.bcPlannerYear = date.getFullYear();
        this.setYearText();
        this.bcPlannerMonth = date.getMonth();
        this.setMonth(date.getMonth());
        this.setMonthText();
        this.createDaysOfMonth();
        this.listeners();
    };
    BcPlannerBehavior.prototype.createHeadersAndPaginator = function () {
        var _this = this;
        var html = "\n    ".concat(this.getPlannerTemplate(), "\n    ").concat(this.getPlannerTop(), "\n    ").concat(this.getPlannerHeader(), "\n    ");
        var element = this.mySelf;
        element.innerHTML += html;
        element.addEventListener('mouseover', function () {
            _this.initModal();
            element.removeEventListener('mouseover', function () {
                _this.initModal();
            });
        });
    };
    BcPlannerBehavior.prototype.getPlannerTemplate = function () {
        return "<article class=\"bc-modal ".concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-modal\" id=\"modalPlanner1\" role='dialog' id='exampleModal' aria-labelledby=\"idModalLabel\" aria-modal=\"true\">\n              <label class=\"bc-modal-close\" for=\"\"></label>\n              <section class=\"bc-modal-container\" customwidth=\"large\" titlealign=\"\" buttonalignment=\"horizontal\" typeicon=\"\" iscancellable=\"false\">\n                <div class=\"bc-modal-close-button-container\">\n                  <button class=\"bc-direction-row bc-icon bc-modal-close-button\" aria-label=\"Close\">error</button>\n                </div>\n                <div class=\"bc-modal-illustration\"></div>\n                <section class=\"bc-modal-title bc-direction-row\">\n                    <h4 id=\"idModalLabel\" class=\"modal-title-label\">T&iacute;tulo</h4>\n                </section>\n                <section class=\"bc-modal-content\">\n                    <div modalcontent=\"\">\n                      <div class=\"").concat(bc_planner_constants_9.MODAL_CALENDAR_NAMESPACE, "-content\"></div>\n                    </div>\n                </section>\n                <section class=\"bc-modal-button-container bc-justify-content-center\">\n                  <button bc-button sizebutton=\"small\" class=\"bc-button-primary bc-button-small bc-w-25\" tabindex=\"0\">CERRAR</button>\n                  <button bc-button sizebutton=\"small\" class=\"bc-button-secondary bc-button-small bc-w-25\" tabindex=\"0\">CERRAR</button>\n                </section>\n                <section class=\"bc-modal-footer\"></section>\n          </section>\n        </article>");
    };
    BcPlannerBehavior.prototype.getPlannerHeader = function () {
        return "<div class=\"".concat(bc_planner_constants_2.PLANNER_HEADER, "\">\n                <div>Lunes</div>\n                <div>Martes</div>\n                <div>Miercoles</div>\n                <div>Jueves</div>\n                <div>Viernes</div>\n                <div>Sabado</div>\n                <div>Domingo</div>\n            </div>");
    };
    BcPlannerBehavior.prototype.getPlannerTop = function () {
        return "<div  class=\"".concat(bc_planner_constants_5.PLANNER_TOP, "\">\n              <div class=\"").concat(bc_planner_constants_5.PLANNER_TOP, "-paginator\">\n                  <div class=\"").concat(bc_planner_constants_3.PLANNER_MONTHS, "\"><a class=\"").concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-btn-previous-month\"><em class=\"bc-icon\">arrow2-left</em></a>\n                      <h5 class=\"").concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-month\"></h5><a class=\"").concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-btn-next-month\"><em class=\"bc-icon\">arrow2-right</em></a>\n                  </div>\n                  <div class=\"").concat(bc_planner_constants_8.PLANNER_YEARS, "\"><a class=\"").concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-btn-previous-year\"><em class=\"bc-icon\">arrow2-left</em></a>\n                      <h5 class=\"").concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-year\"></h5><a class=\"").concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-btn-next-year\"><em class=\"bc-icon\">arrow2-right</em></a>\n                  </div>\n              </div>\n              <div class=\"").concat(bc_planner_constants_5.PLANNER_TOP, "-items\">\n\n              </div>\n            </div>");
    };
    BcPlannerBehavior.prototype.createWeeks = function (weeks) {
        var element = this.mySelf;
        while (element.lastElementChild.classList[0] == "".concat(bc_planner_constants_6.PLANNER_WEEK)) {
            element.removeChild(element.lastElementChild);
        }
        for (var _i = 0, weeks_1 = weeks; _i < weeks_1.length; _i++) {
            var week = weeks_1[_i];
            var weekHtml = this.createHtmlWeeek(week);
            element.innerHTML += weekHtml;
        }
    };
    BcPlannerBehavior.prototype.createHtmlWeeek = function (week) {
        var htmlWeek = "";
        htmlWeek = htmlWeek + "<div class=\"".concat(bc_planner_constants_6.PLANNER_WEEK, "\">");
        for (var _i = 0, _a = week.dates; _i < _a.length; _i++) {
            var day = _a[_i];
            htmlWeek =
                htmlWeek +
                    "<div id=\"bc_planner_view_day_".concat(this.whatMonthorYearBelong(week, day, false), "_").concat(this.whatMonthorYearBelong(week, day, true), "_").concat(day, "\"\n      class=\"").concat(bc_planner_constants_1.PLANNER_DAY, "  ").concat(this.addOpacityDay(week, day), "\">\n        <div class=\"").concat(bc_planner_constants_1.PLANNER_DAY, "-items\">\n\n        </div>\n        <p class=\"").concat(bc_planner_constants_1.PLANNER_DAY, "-number ").concat(this.addClassToday(week, day), "\">").concat(day, "</p>\n      </div>");
        }
        htmlWeek = htmlWeek + "</div>";
        return htmlWeek;
    };
    BcPlannerBehavior.prototype.addOpacityDay = function (week, day) {
        if (day >= week.start && day <= week.end) {
            return '';
        }
        return "".concat(bc_planner_constants_1.PLANNER_DAY, "-number-opacity");
    };
    BcPlannerBehavior.prototype.addClassToday = function (week, day) {
        var today = new Date();
        if (day >= week.start && day <= week.end) {
            if (day == today.getDate() && this.getMonth() == today.getMonth() && this.getYear() == today.getFullYear()) {
                return "".concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-today-number");
            }
        }
        return '';
    };
    BcPlannerBehavior.prototype.whatMonthorYearBelong = function (week, day, isM) {
        var firstDayOfMonth = new Date(this.bcPlannerYear, this.bcPlannerMonth, 1);
        var lastDate = new Date(this.bcPlannerYear, this.bcPlannerMonth + 1, 0);
        var newMonth = this.bcPlannerMonth;
        var newDate = new Date(this.bcPlannerDate);
        if (day >= week.start && day <= week.end) {
            return isM ? newMonth : newDate.getFullYear();
        }
        else {
            if (firstDayOfMonth.getDate() == week.start) {
                newMonth -= 1;
                newDate = new Date(newDate.setMonth(newMonth));
                return isM ? newDate.getMonth() : newDate.getFullYear();
            }
            else if (lastDate.getDate() == week.end) {
                newMonth += 1;
                newDate = new Date(newDate.setMonth(newMonth));
                return isM ? newDate.getMonth() : newDate.getFullYear();
            }
        }
        return isM ? newMonth : newDate.getFullYear();
    };
    BcPlannerBehavior.prototype.getWeeksInMonth = function () {
        var weeks = [], firstDate = new Date(this.bcPlannerYear, this.bcPlannerMonth, 1), lastDate = new Date(this.bcPlannerYear, this.bcPlannerMonth + 1, 0), numDays = lastDate.getDate();
        var dayOffWeek = 6;
        var dayOfWeekCounter = firstDate.getDay() + (firstDate.getDay() == 0 ? dayOffWeek : -1);
        for (var date = 1; date <= numDays; date++) {
            if (dayOfWeekCounter === 0 || weeks.length === 0) {
                weeks.push([]);
            }
            weeks[weeks.length - 1].push(date);
            var defaultDayOfWeekCounter = 7;
            dayOfWeekCounter = (dayOfWeekCounter + 1) % defaultDayOfWeekCounter;
        }
        return weeks
            .filter(function (w) { return !!w.length; })
            .map(function (w) { return ({
            start: w[0],
            end: w[w.length - 1],
            dates: w,
        }); });
    };
    BcPlannerBehavior.prototype.createDaysOfMonth = function () {
        var _a, _b;
        var weeks = this.getWeeksInMonth();
        var dayDefault = 7;
        if (weeks[0].dates.length < dayDefault) {
            var days = dayDefault - weeks[0].dates.length;
            var lastDaysPreviousMonth = [];
            for (var i = 1; i <= days; i++) {
                var firstDayOfMonth = new Date(this.bcPlannerYear, this.bcPlannerMonth, 1);
                var numberDay = new Date(firstDayOfMonth.setDate(1 - i)).getDate();
                lastDaysPreviousMonth.unshift(numberDay);
            }
            (_a = weeks[0].dates).unshift.apply(_a, lastDaysPreviousMonth);
        }
        if (weeks[weeks.length - 1].dates.length < dayDefault) {
            var days = dayDefault - weeks[weeks.length - 1].dates.length;
            var moreDaysNextMonth = [];
            for (var i = 1; i <= days; i++) {
                var lastDayOfMonth = new Date(this.bcPlannerYear, this.bcPlannerMonth + 1, 0);
                var numberDay = new Date(lastDayOfMonth.setDate(i)).getDate();
                moreDaysNextMonth.push(numberDay);
            }
            (_b = weeks[weeks.length - 1].dates).push.apply(_b, moreDaysNextMonth);
        }
        this.createWeeks(weeks);
    };
    BcPlannerBehavior.prototype.getFirstElementByClassName = function (className) {
        var elements = this.mySelf.getElementsByClassName(className);
        if (elements.length > 0) {
            return elements[0];
        }
        return null;
    };
    BcPlannerBehavior.prototype.setMonthText = function () {
        var element = this.getFirstElementByClassName("".concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-month"));
        if (element) {
            element.innerText = this.getMonthName(this.bcPlannerMonth);
        }
    };
    BcPlannerBehavior.prototype.setYearText = function () {
        var element = this.getFirstElementByClassName("".concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-year"));
        if (element) {
            element.innerText = this.getYear();
        }
    };
    BcPlannerBehavior.prototype.setClickNextMonthBtnListener = function () {
        var _this = this;
        var element = this.getFirstElementByClassName(this.bcPlannerNextMonthButton);
        if (element) {
            element.removeEventListener('click', function (e) { return _this.nextMonth(); });
            element.addEventListener('click', function (e) { return _this.nextMonth(); });
        }
    };
    BcPlannerBehavior.prototype.setClickPreviousMonthBtnListener = function () {
        var _this = this;
        var element = this.getFirstElementByClassName(this.bcPlannerPreviousMonthButton);
        if (element) {
            element.removeEventListener('click', function (e) { return _this.previousMonth(); });
            element.addEventListener('click', function (e) { return _this.previousMonth(); });
        }
    };
    BcPlannerBehavior.prototype.setClickNextYearBtnListener = function () {
        var _this = this;
        var element = this.getFirstElementByClassName(this.bcPlannerNextYearButton);
        if (element) {
            element.removeEventListener('click', function (e) { return _this.nextYear(); });
            element.addEventListener('click', function (e) { return _this.nextYear(); });
        }
    };
    BcPlannerBehavior.prototype.setClickPreviousYearBtnListener = function () {
        var _this = this;
        var element = this.getFirstElementByClassName(this.bcPlannerPreviousYearButton);
        if (element) {
            element.removeEventListener('click', function (e) { return _this.previousYear(); });
            element.addEventListener('click', function (e) { return _this.previousYear(); });
        }
    };
    BcPlannerBehavior.prototype.getMonth = function () {
        return this.bcPlannerMonth;
    };
    BcPlannerBehavior.prototype.setMonth = function (Month) {
        this.bcPlannerMonth = Month;
    };
    BcPlannerBehavior.prototype.getMonthName = function (month) {
        return bc_planner_constants_9.MONTHS[month];
    };
    BcPlannerBehavior.prototype.getDayName = function (day) {
        return bc_planner_constants_1.DAYS[day];
    };
    BcPlannerBehavior.prototype.getYear = function () {
        return this.bcPlannerYear;
    };
    BcPlannerBehavior.prototype.getToday = function () {
        return this.bcPlannerToday;
    };
    BcPlannerBehavior.prototype.listeners = function () {
        this.setClickNextMonthBtnListener();
        this.setClickPreviousMonthBtnListener();
        this.setClickNextYearBtnListener();
        this.setClickPreviousYearBtnListener();
    };
    BcPlannerBehavior.prototype.nextMonth = function () {
        var newMonth = this.bcPlannerMonth + 1;
        var newDate = new Date(this.bcPlannerDate.setMonth(newMonth));
        this.setUpDateVariables(newDate);
        this.changesEmitEvent('nextMonth');
    };
    BcPlannerBehavior.prototype.previousMonth = function () {
        var newMonth = this.bcPlannerMonth - 1;
        var newDate = new Date(this.bcPlannerDate.setMonth(newMonth));
        this.setUpDateVariables(newDate);
        this.changesEmitEvent('previousMonth');
    };
    BcPlannerBehavior.prototype.nextYear = function () {
        var newYear = this.bcPlannerYear + 1;
        var newDate = new Date(this.bcPlannerDate.setFullYear(newYear));
        this.setUpDateVariables(newDate);
        this.changesEmitEvent('nextYear');
    };
    BcPlannerBehavior.prototype.previousYear = function () {
        var newYear = this.bcPlannerYear - 1;
        var newDate = new Date(this.bcPlannerDate.setFullYear(newYear));
        this.setUpDateVariables(newDate);
        this.changesEmitEvent('previousYear');
    };
    BcPlannerBehavior.prototype.setItems = function (_items) {
        var _this = this;
        this.items = _items;
        var dates = this.listUnique(JSON.parse(JSON.stringify(_items)), 'date');
        dates.forEach(function (element) {
            _this.refreshItemsHtml(new Date(element));
            _this.orderItemHtml(new Date(element));
        });
    };
    BcPlannerBehavior.prototype.refreshItemsHtml = function (date) {
        var _items = JSON.parse(JSON.stringify(this.getItemsxDate(date)));
        _items.forEach(function (element) {
            var _date = new Date(element.date);
            var dayElement = document.getElementById("bc_planner_view_day_".concat(_date.getFullYear(), "_").concat(_date.getMonth(), "_").concat(_date.getDate()));
            if (dayElement) {
                dayElement.firstElementChild.innerHTML = '';
            }
        });
    };
    BcPlannerBehavior.prototype.listUnique = function (List, Column) {
        var uniques = List.map(function (data) { return data[Column]; });
        return uniques.filter(function (x, i, a) { return x && a.indexOf(x) === i; }).sort();
    };
    BcPlannerBehavior.prototype.setItemHtml = function (item) {
        var html = this.buildItemHtml(item, "".concat(bc_planner_constants_1.PLANNER_DAY, "-item"));
        var date = new Date(item.date);
        item.date = date;
        var dayElement = document.getElementById("bc_planner_view_day_".concat(date.getFullYear(), "_").concat(date.getMonth(), "_").concat(date.getDate()));
        if (dayElement) {
            dayElement.firstElementChild.innerHTML += html;
        }
    };
    BcPlannerBehavior.prototype.addEventsItem = function (Items) {
        var _this = this;
        Items.forEach(function (item) {
            if (item.preview) {
                _this.eventPreview(item);
            }
        });
    };
    BcPlannerBehavior.prototype.eventPreview = function (item) {
        var date = new Date(item.date);
        item.date = date;
        var dayElement = document.getElementById("bc_planner_view_day_".concat(date.getFullYear(), "_").concat(date.getMonth(), "_").concat(date.getDate()));
        if (dayElement) {
            var elements = dayElement.firstElementChild.querySelectorAll("p[class$=id_".concat(item.id, "]"));
            this.addEvent('click', elements[0], item, 0);
        }
    };
    BcPlannerBehavior.prototype.buildItemHtml = function (item, nameClass) {
        var color = item.color ? "style=\"color:".concat(item.color, ";\"") : "";
        var icon = item.icon ? "<em class=\"bc-icon\" ".concat(color, ">").concat(item.icon, "</em>") : "";
        return "<p class=\"".concat(nameClass, " id_").concat(item.id, "\">\n                  ").concat(icon, "\n                  ").concat(item.title, "\n                </p>\n    ");
    };
    BcPlannerBehavior.prototype.setItemPlus = function (item, date) {
        var _this = this;
        var html = "<p class=\"".concat(bc_planner_constants_1.PLANNER_DAY, "-item ").concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-item-plus\">\n                   +").concat(item, "\n                </p>\n    ");
        var dayElement = document.getElementById("bc_planner_view_day_".concat(date.getFullYear(), "_").concat(date.getMonth(), "_").concat(date.getDate()));
        if (dayElement) {
            dayElement.firstElementChild.innerHTML += html;
            var plusE = dayElement.firstElementChild.getElementsByClassName("".concat(bc_planner_constants_4.PLANNER_NAMESPACE, "-item-plus"))[0];
            plusE.removeEventListener('click', function (event) {
                _this.openModalPlanner(date);
            });
            plusE.addEventListener('click', function (event) {
                _this.openModalPlanner(date);
            });
        }
    };
    BcPlannerBehavior.prototype.closeModal = function () {
        this.modalListPlus.closeModal();
    };
    BcPlannerBehavior.prototype.openModalPlanner = function (date) {
        var _this = this;
        var Items = this.getItemsxDate(date);
        this.modalListPlus.openModal();
        var modal = this.modalListPlus.getMySelf();
        var thisModal = this.mySelf.querySelector('#modalPlanner1');
        this.mySelf.replaceChild(modal, thisModal);
        this.modifyModal(this.items[0], 1);
        var parent = this.mySelf.querySelector("div[class=".concat(bc_planner_constants_9.MODAL_CALENDAR_NAMESPACE, "-content]"));
        parent.innerHTML = '';
        Items.forEach(function (item) {
            var htmlItem = _this.buildItemModalHtml(item, 'bc-modal-planner-item');
            parent.innerHTML += htmlItem;
        });
        this.addEventsEm(Items);
    };
    BcPlannerBehavior.prototype.addEventsEm = function (Items) {
        var _this = this;
        Items.forEach(function (item) {
            if (item.preview) {
                var em = _this.getFirstElementByClassName("".concat(item.preview.id));
                _this.addEvent('click', em, item, bc_planner_constants_7.MODAL_TWO);
            }
        });
    };
    BcPlannerBehavior.prototype.addEvent = function (_event, elemento, item, op) {
        var _this = this;
        elemento.removeEventListener(_event, function () {
            _this.openModalPreview(item, op);
        });
        elemento.addEventListener(_event, function () {
            _this.openModalPreview(item, op);
        });
    };
    BcPlannerBehavior.prototype.buildItemModalHtml = function (item, nameClass) {
        var color = item.color ? "style=\"color:".concat(item.color, ";\"") : "";
        var icon = item.icon ? "<em class=\"bc-icon\" ".concat(color, ">").concat(item.icon, "</em>") : "";
        var iconAction = item.preview ? "<em class=\"bc-icon bc-pointer ".concat(item.preview.id, "\" >arrow2-right</em>") : "";
        return "\n    <div class=\"bc-card ".concat(nameClass, "\">\n     ").concat(icon, "\n      <div class=\"bc-card-body\">\n        <p class=\"bc-card-subtitle bc-align-left\">").concat(item.title, "</p>\n        <p class=\"bc-card-subtitle-number bc-align-left\">").concat(item.text, "</p>\n      </div>\n      ").concat(iconAction, "\n    </div>");
    };
    BcPlannerBehavior.prototype.openModalPreview = function (item, op) {
        var _this = this;
        this.modalListPlus.openModal();
        var modal = this.modalListPlus.getMySelf();
        var thisModal = this.mySelf.querySelector('#modalPlanner1');
        this.mySelf.replaceChild(modal, thisModal);
        this.modifyModal(item, op);
        var parent = this.mySelf.querySelector("div[class=".concat(bc_planner_constants_9.MODAL_CALENDAR_NAMESPACE, "-content]"));
        parent.innerHTML = '';
        item.preview.items.forEach(function (_item) {
            var htmlItem = _this.buildPreviewModalHtml(_item, 'bc-modal-planner-preview');
            parent.innerHTML += htmlItem;
        });
    };
    BcPlannerBehavior.prototype.modifyModal = function (item, _modal) {
        var childcontainer = document.querySelector('div[class^=bc-modal-button-container]');
        if (childcontainer) {
            var btn = childcontainer.getElementsByTagName('button')[0];
            var btn2 = childcontainer.getElementsByTagName('button')[1];
            if (_modal == 1) {
                this.mModal1(item, btn, btn2);
            }
            else if (_modal == bc_planner_constants_7.MODAL_TWO || _modal == 0) {
                this.mModal2(item, btn, btn2, _modal);
            }
        }
    };
    BcPlannerBehavior.prototype.mModal1 = function (item, btn, btn2) {
        var _this = this;
        var title = document.querySelector('div[class^=bc-modal-title]');
        title.firstElementChild.innerHTML =
            this.getDayName(item.date.getDay()) +
                ' ' +
                item.date.getDate() +
                ' de ' +
                this.getMonthName(item.date.getMonth()) +
                ' del ' +
                item.date.getFullYear();
        if (btn) {
            btn.style.display = 'none';
        }
        if (btn2) {
            btn2.innerText = 'CERRAR';
            btn2.classList.replace('bc-button-secondary', 'bc-button-primary');
            btn2.removeEventListener('click', function () {
                _this.closeModal();
            });
            btn2.addEventListener('click', function () {
                _this.closeModal();
            });
        }
    };
    BcPlannerBehavior.prototype.mModal2 = function (item, btn, btn2, _modal) {
        var _this = this;
        var title = document.querySelector('div[class^=bc-modal-title]');
        title.firstElementChild.innerHTML = 'Detalle del evento';
        if (btn) {
            btn.style.display = 'inline-block';
            btn.innerText = item.preview.actionText;
            btn.classList.replace('bc-w-25', 'bc-w-50');
            btn.removeEventListener('click', function () {
                _this.valueEmitEvent(item);
            });
            btn.addEventListener('click', function () {
                _this.valueEmitEvent(item);
            });
        }
        if (btn2) {
            btn2.innerText = 'REGRESAR';
            btn2.classList.replace('bc-button-primary', 'bc-button-secondary');
            if (_modal == bc_planner_constants_7.MODAL_TWO) {
                btn2.removeEventListener('click', function () {
                    _this.openModalPlanner(item.date);
                });
                btn2.addEventListener('click', function () {
                    _this.openModalPlanner(item.date);
                });
            }
            else {
                btn2.removeEventListener('click', function () {
                    _this.closeModal();
                });
                btn2.addEventListener('click', function () {
                    _this.closeModal();
                });
            }
        }
    };
    BcPlannerBehavior.prototype.buildPreviewModalHtml = function (item, nameClass) {
        return "\n    <div class=\"".concat(nameClass, "\">\n        <p class=\"small bc-align-left\">").concat(item.title, "</p>\n        <p class=\"bc-align-left\">").concat(item.text, "</p>\n    </div>");
    };
    BcPlannerBehavior.prototype.setForitemHtml = function (_items, _length) {
        for (var i = 0; i < _length; i++) {
            this.setItemHtml(_items[i]);
        }
    };
    BcPlannerBehavior.prototype.orderItemHtml = function (date) {
        var _items = JSON.parse(JSON.stringify(this.getItemsxDate(date)));
        var twoItems = 2;
        var threeItems = 3;
        var fourItems = 4;
        var sixteen = 16;
        var thirty = 30;
        var thirtyFive = 35;
        var numplus = 0;
        if (_items.length > 1) {
            numplus = this.moreOneitem(_items, thirty, numplus, twoItems, threeItems, fourItems, sixteen);
        }
        else if (_items.length == 1) {
            if (_items[0].title.length > thirtyFive) {
                _items[0].title = _items[0].title.slice(0, thirtyFive) + '...';
                this.setItemHtml(_items[0]);
                numplus = 1;
            }
            else {
                this.setItemHtml(_items[0]);
            }
        }
        if (numplus > 0) {
            this.setItemPlus(numplus.toString(), new Date(_items[0].date));
        }
        this.addEventsItem(_items);
    };
    BcPlannerBehavior.prototype.moreOneitem = function (_items, thirty, numplus, twoItems, threeItems, fourItems, sixteen) {
        if (_items[0].title.length > thirty) {
            _items[0].title = _items[0].title.slice(0, thirty) + '...';
            this.setItemHtml(_items[0]);
            numplus = _items.length - 1;
        }
        else if (_items.length == twoItems) {
            numplus = this.thowItems(_items, thirty, numplus);
            this.setForitemHtml(_items, _items.length);
        }
        else if (_items.length == threeItems) {
            numplus = this.threeItems(_items, thirty, numplus);
            this.setForitemHtml(_items, _items.length - (numplus > 0 ? 1 : 0));
        }
        else if (_items.length >= fourItems) {
            numplus = this.fourOrMoreItems(_items, fourItems, threeItems, sixteen, numplus);
        }
        return numplus;
    };
    BcPlannerBehavior.prototype.fourOrMoreItems = function (_items, fourItems, threeItems, sixteen, numplus) {
        if (_items.length == fourItems && _items[threeItems].title.length > sixteen) {
            this.setForitemHtml(_items, _items.length - 1);
            numplus = 1;
        }
        else if (_items.length == fourItems && _items[threeItems].title.length <= sixteen) {
            this.setForitemHtml(_items, _items.length);
        }
        else if (_items.length > fourItems) {
            this.setForitemHtml(_items, fourItems);
        }
        return numplus;
    };
    BcPlannerBehavior.prototype.threeItems = function (_items, thirty, numplus) {
        if (_items[0].title.length > thirty) {
            _items[0].title = _items[0].title.slice(0, thirty) + '...';
            numplus = _items.length;
        }
        if (_items[1].title.length > thirty) {
            _items[1].title = _items[1].title.slice(0, thirty) + '...';
            numplus = _items.length;
        }
        return numplus;
    };
    BcPlannerBehavior.prototype.thowItems = function (_items, thirty, numplus) {
        if (_items[0].title.length > thirty) {
            _items[0].title = _items[0].title.slice(0, thirty) + '...';
            numplus = _items.length;
        }
        if (_items[1].title.length > thirty) {
            _items[1].title = _items[1].title.slice(0, thirty) + '...';
            numplus = _items.length;
        }
        return numplus;
    };
    BcPlannerBehavior.prototype.setItemsTop = function (_items) {
        var _this = this;
        var topElement = this.mySelf.querySelector(".".concat(bc_planner_constants_5.PLANNER_TOP, "-items"));
        if (topElement) {
            topElement.innerHTML = '';
            _items.forEach(function (_item) {
                _this.setItemTopHtml(_item, topElement);
            });
        }
    };
    BcPlannerBehavior.prototype.setItemTopHtml = function (item, topElement) {
        var color = item.color ? "style=\"color:".concat(item.color, " ;\"") : "";
        var icon = item.icon ? "<em class=\"bc-icon\" ".concat(color, ">").concat(item.icon, "</em>") : "";
        var html = "<p class=\"".concat(bc_planner_constants_5.PLANNER_TOP, "-item\">\n                 ").concat(icon, "\n                 ").concat(item.title, "\n                </p>\n    ");
        if (topElement) {
            topElement.innerHTML += html;
        }
    };
    BcPlannerBehavior.prototype.getItems = function () {
        return this.items;
    };
    BcPlannerBehavior.prototype.getItemsxDate = function (date) {
        return this.items.filter(function (a) {
            if (a.date.getMonth() == date.getMonth() &&
                a.date.getFullYear() == date.getFullYear() &&
                a.date.getDate() == date.getDate()) {
                return true;
            }
            return false;
        });
    };
    BcPlannerBehavior.prototype.getItem = function (id) {
        var result = this.items.filter(function (i) { return i.id == id; });
        if (result.length > 0) {
            return result[0];
        }
        return null;
    };
    BcPlannerBehavior.prototype.changesEmitEvent = function (action) {
        var values = {
            action: action,
            monthValue: this.getMonth(),
            yearValue: this.getYear(),
        };
        if (this.outputChanges) {
            this.outputChanges(values);
        }
    };
    BcPlannerBehavior.prototype.valueEmitEvent = function (item) {
        if (this.outputValues) {
            this.outputValues(item.preview.dataReturn);
        }
    };
    return BcPlannerBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcPlannerBehavior = BcPlannerBehavior;
